<template>
  <input
    type="text"
    name="search"
    class="search-input"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    @keydown.enter="$refs.input.blur()"
    ref="input"
    :placeholder="placeholder"
    tabindex="0"
  />
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style  lang="scss">
@import "../../scss/importall.scss";

.search-input {
  @extend %h1;
  width: 100%;
  appearance: none;
  outline: none;
  color: inherit;
  background: none;
  border: none;
  border-bottom: 2px solid currentColor;
  transition: opacity 0.15s ease-in-out;

  &:empty {
    opacity: 0.5;
  }

  &::placeholder {
    color: inherit;
  }
}
</style>
